import { render, staticRenderFns } from "./RenaperConsultar.vue?vue&type=template&id=87802ca8&scoped=true"
import script from "./RenaperConsultar.vue?vue&type=script&lang=js"
export * from "./RenaperConsultar.vue?vue&type=script&lang=js"
import style0 from "./RenaperConsultar.vue?vue&type=style&index=0&id=87802ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87802ca8",
  null
  
)

export default component.exports